// extracted by mini-css-extract-plugin
module.exports = {"IconLabel":"IconWithLabel_IconLabel__buLj7","IconLabel__name":"IconWithLabel_IconLabel__name__Hv68V","IconLabel__generation":"IconWithLabel_IconLabel__generation__3_C8R"};